import { jsx as _jsx } from "react/jsx-runtime";
export function ProfilePage() {
    return _jsx("div", { children: _jsx("h1", { children: "Profile" }) });
}
//# sourceMappingURL=profile-page.js.map